import { createContext } from 'react'
import {TypeContextNavMeta } from 'Type'

const ContextNavMeta = createContext<TypeContextNavMeta>({map: {}, fetchMeta: () => {}})

export default ContextNavMeta